import novus_studio_novusCodeStr from "!!raw-loader!..\\..\\..\\..\\content\\blog\\novus\\novus.tsx";
import novus_studio_novusCodeStr1 from "!!raw-loader!..\\..\\..\\..\\content\\blog\\novus\\todoModel.ts";
import novus_studio_novusCodeStr2 from "!!raw-loader!..\\..\\..\\..\\content\\blog\\novus\\example.tsx";
import { ExampleTodoExample } from "..\\..\\..\\..\\content\\blog\\novus\\example.js";
import React from 'react';
export default {
  novus_studio_novusCodeStr,
  novus_studio_novusCodeStr1,
  novus_studio_novusCodeStr2,
  ExampleTodoExample,
  React
};